import { render, staticRenderFns } from "./EditProjectDepartments.vue?vue&type=template&id=5fa47b6c&scoped=true&"
import script from "./EditProjectDepartments.vue?vue&type=script&lang=js&"
export * from "./EditProjectDepartments.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectDepartments.vue?vue&type=style&index=0&id=5fa47b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa47b6c",
  null
  
)

export default component.exports